import React, { useState } from "react";
import { useTransactions } from "./../hooks/useTransactions";
import {
    ArrowDown,
    ArrowUp,
    ArrowLeftRight,
    Receipt,
    Download,
    Search,
    Calendar,
    Filter,
    ChevronDown,
    MoreHorizontal,
} from "lucide-react";

import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { MobileHeader } from "./MobileHeader";

// const stats = [
//     {
//         title: "Money In",
//         value: "₹8,325.00",
//         subtitle: "from 56 transactions",
//         icon: <ArrowUp size={28} />,
//         color: "green",
//     },
//     {
//         title: "Money Out",
//         value: "₹9,900.00",
//         subtitle: "from 132 transactions",
//         icon: <ArrowDown size={28} />,
//         color: "red",
//     },
//     {
//         title: "Net Flow",
//         value: "-₹1,575.00",
//         subtitle: "this period",
//         icon: <ArrowLeftRight size={28} />,
//         color: "blue",
//     },
//     {
//         title: "Total Transactions",
//         value: "188",
//         subtitle: "this period",
//         icon: <Receipt size={28} />,
//         color: "gray",
//     },
// ];

function StatusBadge({ status }) {
    return (
        <span className="status-badge completed">
            {status}
        </span>
    );
}

function TypeBadge({ type }) {

    let icon;
    let color;
    let label;

    switch (type) {

        case "topup":
            icon = <ArrowUp size={14} />;
            color = "positiveBlue";
            label = "Top-up";
            break;

        case "referral":
            icon = <ArrowUp size={14} />;
            color = "positive";
            label = "Referral";
            break;

        case "withdrawal":
            icon = <ArrowDown size={14} />;
            color = "withdrawal";
            label = "Withdrawal";
            break;

        case "redemption":
            icon = <ArrowDown size={14} />;
            color = "negative";
            label = "Redemption";
            break;

        default:
            icon = <ArrowDown size={14} />;
            color = "";
            label = type;

    }

    return (

        <div className="transaction-type">

            <div className={`transaction-type-icon ${color}`}>

                {icon}

            </div>

            <span>{label}</span>

        </div>

    );

}

function StatCard({ stat }) {
    return (
        <div className="offer-stat-card">

            <div className={`offer-stat-icon ${stat.color}`}>

                {stat.icon}

            </div>

            <div className="offer-stat-content">

                <div className="offer-stat-title">

                    {stat.title}

                    {/* <Info
                        size={15}
                        style={{ marginLeft: 6 }}
                    /> */}

                </div>

                <div className="offer-stat-value">

                    ₹{stat.value}

                </div>

                <div className="offer-stat-subtitle">

                    {stat.subtitle}

                </div>

            </div>

        </div>
    );
}

export function Transactions() {

    const [search, setSearch] = useState("");

    const {
        data,
        isLoading,
        error,
    } = useTransactions();

    if (isLoading) {
        return (

            <div className="page-state">

                <div className="page-state-spinner" />

                <h2>

                    Loading...

                </h2>

                <p>

                    We're fetching your latest data.

                </p>

            </div>

        );
    }

    if (error) {
        return (

            <div className="page-state">

                <div className="page-state-icon">

                    !

                </div>

                <h2>

                    Something went wrong

                </h2>

                <p>

                    We couldn't load this page. Please try refreshing or come back in a moment.

                </p>

                <button

                    className="primary-btn"

                    onClick={() => window.location.reload()}

                >

                    Try Again

                </button>

            </div>

        );
    }

    const stats = [
        {
            title: "Money In",
            value: data.totalMoneyIn,
            subtitle: "from " + data.numberOfMoneyInTransactions + " transactions all time",
            icon: <ArrowUp size={28} />,
            color: "green",
        },
        {
            title: "Money Out",
            value: data.totalMoneyOut,
            subtitle: "from " + data.numberOfMoneyOutTransactions + " transactions all time",
            icon: <ArrowDown size={28} />,
            color: "red",
        },
        {
            title: "Net Flow",
            value: data.netflow,
            subtitle: "all time",
            icon: <ArrowLeftRight size={28} />,
            color: "blue",
        },
        {
            title: "Total Transactions",
            value: data.totalTransactions,
            subtitle: "all time",
            icon: <Receipt size={28} />,
            color: "gray",
        },
    ];

    return (

        <div className="offers-page">

            <MobileHeader />

            <Sidebar />

            <div className="offers-content">
                <Header
                    title="Transactions"
                    subtitle="All money in and out of your account."
                    action={
                        <button className="secondary-btn">

                            <Download size={18} />

                            Export

                        </button>
                    }
                />

                <div className="offer-stats-grid">

                    {stats.map((stat) => (

                        <StatCard
                            key={stat.title}
                            stat={stat}
                        />

                    ))}

                </div>

                <div className="offers-filters">

                    <div className="search-box">

                        <Search size={18} />

                        <input
                            placeholder="Search by description, reference ID or offer"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />

                    </div>

                    <select className="filter-select">

                        <option>All Types</option>

                    </select>

                    <select className="filter-select">

                        <option>All Status</option>

                    </select>

                    <button className="secondary-btn">

                        <Calendar size={18} />

                        May 20 – Jun 19, 2025

                        <ChevronDown size={16} />

                    </button>

                    <button className="secondary-btn">

                        <Filter size={18} />

                        Filters

                    </button>

                </div>

                {/* Transaction table continues in Part 2 */}

                <div className="offers-table-card">

                    <table className="offers-table">

                        <thead>

                            <tr>

                                <th>Date & Time</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Reference ID</th>
                                <th>Amount</th>
                                <th>Balance After</th>
                                <th>Status</th>
                                <th></th>

                            </tr>

                        </thead>

                        <tbody>

                            {data.transactions
                                .filter((transaction) => {

                                    if (search.trim() === "") return true;

                                    const q = search.toLowerCase();

                                    return (
                                        transaction.description.toLowerCase().includes(q) ||
                                        transaction.reference.toLowerCase().includes(q)
                                    );

                                })
                                .map((transaction) => (

                                    <tr key={transaction.transactionUid}>

                                        <td>

                                            {new Date(transaction.createdAt).toLocaleString("en-IN", {
                                                day: "2-digit",
                                                month: "short",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })}

                                        </td>

                                        <td>

                                            <TypeBadge type={transaction.type} />

                                        </td>

                                        <td>

                                            {transaction.title}

                                        </td>

                                        <td>

                                            {transaction.transactionUid}

                                        </td>

                                        <td>

                                            <span
                                                className={
                                                    transaction.type === "topup"
                                                        ? "positiveBlue"
                                                        : transaction.type === "referral"
                                                            ? "positive"
                                                            : transaction.type === "withdrawal"
                                                                ? "withdrawal"
                                                                : "negative"
                                                }
                                            >

                                                {transaction.amount >= 0
                                                    ? `+₹${transaction.amount}`
                                                    : `-₹${Math.abs(transaction.amount)}`}

                                            </span>

                                        </td>

                                        <td>

                                            ₹{transaction.balanceAfter}

                                        </td>

                                        <td>

                                            <StatusBadge
                                                status={transaction.status}
                                            />

                                        </td>

                                        <td>

                                            <button className="icon-button">

                                                <MoreHorizontal size={18} />

                                            </button>

                                        </td>

                                    </tr>

                                ))}

                        </tbody>

                    </table>

                    <div className="offers-pagination">

                        <span>

                            Showing 1 to {data.totalTransactions} of {data.totalTransactions} transactions

                        </span>

                        <div className="pagination-buttons">

                            <button>

                                Previous

                            </button>

                            <button className="active">

                                1

                            </button>

                            <button>

                                2

                            </button>

                            <button>

                                3

                            </button>

                            <button>

                                4

                            </button>

                            <button>

                                ...

                            </button>

                            <button>

                                24

                            </button>

                            <button>

                                Next

                            </button>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}